export default function initAppDialogs( { store, } ) {
	return {
		// header: String,
		// description: String,
		// actions: [
		// 	{
		// 		id: "archive",
		// 		type: "PRIMARY",
		// 		label: String,
		// 		isDestructive: Boolean,
		// 		onButtonPress: Function,
		// 	},
		// 	{
		// 		id: "cancel",
		// 		type: "QUATERNARY",
		// 		label: String,
		// 		isDestructive: Boolean,
		// 		onButtonPress: Function,
		// 	},
		// ],
		// meta: {}
		requestUserConfirmation( { header, description, actions, metadata, } ) {
			store.commit( "host-dialogs/requestUserConfirmation", {
				header, description, actions, metadata,
			} );
		},
		requestSimpleConfirmation( {
			header,
			description,
			confirmText,
			cancelText,
			onConfirm,
			onCancel,
		} ) {
			store.commit( "host-dialogs/requestSimpleConfirmation", {
				header,
				description,
				confirmText,
				cancelText,
				onConfirm,
				onCancel,
			} );
		},
	};
}
